import React from 'react'

export default function CommunityCategoryFilter({ categories, selectedCategoryId, onSelect, colors }) {
  const allTab = { id: null, name: 'All' }
  const tabs = [allTab, ...(categories || [])]

  return (
    <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide -mx-1 px-1">
      {tabs.map((tab) => {
        const isActive = selectedCategoryId === tab.id
        return (
          <button
            key={tab.id ?? '__all__'}
            onClick={() => onSelect(tab.id)}
            className={`flex-shrink-0 px-4 py-1.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap border ${
              isActive
                ? 'text-white border-transparent'
                : 'bg-white text-gray-600 border-gray-200 hover:border-gray-300 hover:text-gray-800'
            }`}
            style={isActive ? { backgroundColor: colors?.primary || '#3366FF', borderColor: colors?.primary || '#3366FF' } : {}}
          >
            {tab.name}
          </button>
        )
      })}
    </div>
  )
}
